// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p,
h1 {
  margin: unset;
}

ion-header {
  box-shadow: none;
}

.toolbar {
  background: var(--background-default);
  flex-wrap: nowrap !important;
  display: flex;
}
.toolbar p {
  color: white;
  font-size: 10px;
}

.category-block {
  background: #fff;
}

ion-content {
  background: transparent !important;
  --background: transparent !important;
}

ion-icon.brand-logo {
  width: 140px;
  height: 18px;
}

.main {
  overflow: auto;
}

.item-responsive {
  width: 100%;
}
@media (min-width: 991px) {
  .item-responsive {
    width: calc(33.333% - 10px);
    margin: 0 5px 10px;
  }
}

.articles-wrapper {
  padding: 0 16px;
}
@media (min-width: 991px) {
  .articles-wrapper {
    margin: 0 -16px;
  }
}

ion-searchbar {
  padding-inline-end: 12px;
  padding-inline-start: 25px;
  --placeholder-color: #41413f;
  --placeholder-opacity: 1;
  --color: #41413f;
  --icon-color: #41413f;
  --border-radius: 10px;
  --border: none;
  --background: rgba(255, 255, 255, 0.15);
}
@media (min-width: 991px) {
  ion-searchbar {
    width: auto;
  }
}

.menu-heading {
  padding-top: 10px;
  background: #e7f0f1;
  padding-bottom: 10px;
}
@media (min-width: 991px) {
  .menu-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e7f0f1;
  }
}

.list-title {
  margin-bottom: 15px;
}

.orders {
  overflow: auto;
  flex: 1;
  padding-bottom: 10px;
}

.items-wrap h3 {
  margin-top: 0;
  margin-bottom: 12px;
  font-weight: bolder;
}
.main-row {
  height: 100%;
  overflow: hidden;
}

app-order-content {
  display: block;
  height: 100%;
}

.order-col {
  min-width: 380px;
}

.category-header {
  height: 80px;
  width: 100%;
  position: relative;
}
.category-header .category-headr-img {
  height: 80px;
  width: 100%;
  object-fit: cover;
  opacity: 0.7;
  z-index: 0.6;
}
.category-header h3 {
  position: absolute;
  z-index: 10;
  top: 50%;
  color: var(--ion-color-primary);
  left: 25px;
  transform: translateY(-50%);
}
@media (min-width: 991px) {
  .category-header {
    margin-top: 20px;
  }
}

.category-wrap {
  margin-bottom: 22px;
}
.category-wrap .category-info {
  padding-left: 16px;
  background: white;
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  background: linear-gradient(89.92deg, rgba(255, 255, 255, 0.98) 55%, rgba(0, 0, 0, 0) 100%);
  border-width: 1px 0px 2px 0px;
  border-style: solid;
  border-color: #000000;
}
.category-wrap .category-info .category-name {
  width: 100%;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
  z-index: 9999;
  font-size: 20px;
  line-height: 100%;
  vertical-align: middle;
  text-transform: capitalize;
  letter-spacing: 0.02em;
  color: #212326;
}
.category-wrap .category-info .category-description {
  z-index: 1;
  font-family: AppFontAlt;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  color: #212326;
  margin-top: 7px;
}
.category-wrap .category-info ion-img {
  object-fit: cover;
  right: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
}

.header-wrap {
  padding-left: 11px;
}

.padding-end {
  padding-right: 11px;
}

ion-footer {
  padding: 20px;
  position: fixed;
  bottom: 0;
  backdrop-filter: blur(4px);
  background: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%);
}

@media (min-width: 991px) {
  .footer-btn {
    display: none;
  }
}

.category-list {
  display: flex;
  align-items: center;
  gap: 6px;
  transition: 1s linear;
  opacity: 1;
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
  background-color: #fff;
  height: 64px;
  padding-inline: 20px;
  margin-bottom: 6px;
}
.category-list::-webkit-scrollbar {
  display: none;
}
.category-list .chip {
  flex: 0 0 auto;
  --icon-color: var(--ion-color-primary);
  height: 39px;
  background: transparent;
  border: 1px solid #41413f;
  transition: 200ms linear;
  min-width: 41px;
  flex-direction: column;
  padding: 0 15px !important;
  margin: 0;
  border-radius: 3px;
  justify-content: center;
}
.category-list .chip:first-child {
  margin-left: 0px;
}
.category-list .chip:last-child {
  margin-right: 0px;
}
.category-list .chip ion-label {
  margin: 0;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0;
  vertical-align: bottom;
  text-transform: capitalize;
  color: #41413f;
}
.category-list .chip.selected {
  transition: 200ms linear;
  background: var(--ion-color-tertiary);
  box-shadow: 1px 1px 0px 1px;
}
.category-list .chip.selected ion-label {
  color: #050b05;
}
.category-list .chip .icon {
  height: 17px;
  width: 17px;
  --icon-color: #41413f;
  margin: 0;
}
.category-list .chip.chip-icon {
  width: 39px;
}

.menu-heading {
  padding-top: 10px;
  background: #6b5f4c;
  padding-bottom: 10px;
}
@media (min-width: 991px) {
  .menu-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e7f0f1;
  }
}

.search-block {
  height: 64px;
  display: flex;
  align-items: center;
  opacity: 1;
  transition: 1s linear;
  margin-bottom: 6px;
}

.hidden {
  opacity: 0;
  display: none;
  transition: 1s linear;
}

.main-row {
  height: 100%;
  overflow: hidden;
}

.service-not-available-container {
  --padding-start: 20px !important;
  --padding-end: 10px;
  --padding-top: 10px;
  --padding-bottom: 10px;
}
.service-not-available-container ion-icon {
  color: #fff !important;
}

.banner-row {
  height: 48px;
  overflow: hidden;
  transition: transform 1s ease-in-out, height 1s ease-in-out;
}
@media (max-width: 992px) {
  .banner-row {
    height: 60px;
  }
}
.banner-row.hide {
  height: 0;
  transform: rotateX(45deg) translate(0, -150%);
}

.allergen-banner {
  height: 100%;
  background: #666666;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px !important;
  padding-right: 16px;
}
.allergen-banner ion-icon {
  fill: #fff;
  margin-right: 15px;
  height: 27px;
  width: 32px;
}
.allergen-banner .info {
  width: 100%;
  margin: 0;
  padding-block: 5px;
  font-family: AppFont !important;
  font-size: 10px !important;
  line-height: 13.2px !important;
  color: #fff !important;
  text-wrap: balance;
}
.allergen-banner a {
  font-family: AppFontBold;
  font-size: 10px;
  color: var(--ion-color-primary);
}

.expand-block {
  position: fixed;
  height: 100vh;
  width: 100vw;
  right: -100%;
  top: 0;
  background: rgba(0, 0, 0, 0.1019607843);
  z-index: 10;
}
@media (max-width: 992px) {
  .expand-block {
    display: none;
  }
}
.expand-block.show {
  right: 0%;
}

.sidebar {
  position: absolute;
  right: -100%;
  top: 0;
  width: 35vw;
  height: 100vh;
  background: #fff;
  z-index: 11;
  display: flex;
  flex-direction: column;
  transition: right 0.3s ease-in-out;
}
@media (max-width: 992px) {
  .sidebar {
    display: none;
  }
}
.sidebar.show {
  right: 0%;
}

app-order-content {
  display: block;
  height: 100%;
  background: #f2f2f2;
}

.fixed-notification {
  position: fixed;
  bottom: 109px;
  left: 50%;
  transform: translateX(-50%);
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(30, 30, 28, 0.8);
  backdrop-filter: blur(4px);
  z-index: 9999;
  opacity: 0;
  transition: 0.3s ease;
}
@media (min-width: 991px) {
  .fixed-notification {
    bottom: 0px;
  }
}
.fixed-notification::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -12px;
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-top: 12px solid rgba(30, 30, 28, 0.8);
  backdrop-filter: blur(4px);
}
.fixed-notification ::ng-deep.inner-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #fff;
  padding: 0 10px;
}
.fixed-notification ::ng-deep.inner-text span {
  font-family: AppFontSemiBold;
  color: #fff;
}

.placeholder-block {
  height: 200px;
}

.fixed-notification.show-item {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;;EAEC,aAAA;AAAD;;AAGA;EACC,gBAAA;AAAD;;AAGA;EACC,qCAAA;EACA,4BAAA;EACA,aAAA;AAAD;AACC;EACC,YAAA;EACA,eAAA;AACF;;AAGA;EACC,gBAAA;AAAD;;AAEA;EACC,kCAAA;EACA,oCAAA;AACD;;AACA;EACC,YAAA;EACA,YAAA;AAED;;AACA;EACC,cAAA;AAED;;AACA;EACC,WAAA;AAED;ACtCE;EDmCF;IAGE,2BAAA;IACA,kBAAA;EAIA;AACF;;AADA;EACC,eAAA;AAID;AChDE;ED2CF;IAGE,eAAA;EAMA;AACF;;AAHA;EACC,wBAAA;EACA,0BAAA;EACA,4BAAA;EACA,wBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,uCAAA;AAMD;ACjEE;EDkDF;IAWE,WAAA;EAQA;AACF;;AANA;EACC,iBAAA;EACA,mBAAA;EACA,oBAAA;AASD;AC5EE;EDgEF;IAKE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,gCAAA;EAWA;AACF;;AARA;EACC,mBAAA;AAWD;;AARA;EACC,cAAA;EACA,OAAA;EACA,oBAAA;AAWD;;AAPC;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;AAUF;AAFA;EACC,YAAA;EACA,gBAAA;AAID;;AADA;EACC,cAAA;EACA,YAAA;AAID;;AADA;EACC,gBAAA;AAID;;AAFA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAKD;AAJC;EACC,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;AAMF;AAJC;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,+BAAA;EACA,UAAA;EACA,2BAAA;AAMF;ACtIE;ED+GF;IAoBE,gBAAA;EAOA;AACF;;AAJA;EACC,mBAAA;AAOD;AANC;EACC,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,2FAAA;EACA,6BAAA;EACA,mBAAA;EACA,qBAAA;AAQF;AANE;EACC,WAAA;EAEA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,sBAAA;EAEA,cAAA;AAIH;AADE;EACC,UAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EAEA,eAAA;AAEH;AACE;EACC,iBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AACH;;AAQA;EACC,kBAAA;AALD;;AAOA;EACC,mBAAA;AAJD;;AAMA;EACC,aAAA;EACA,eAAA;EACA,SAAA;EACA,0BAAA;EACA,4GAAA;AAHD;;ACjNE;EDsNF;IAEE,aAAA;EAFA;AACF;;AAIA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,YAAA;EAEA,sBAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AAHD;AAKC;EACC,aAAA;AAHF;AAMC;EASC,cAAA;EACA,sCAAA;EACA,YAAA;EAEA,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;EAEA,uBAAA;AAdF;AAPE;EACC,gBAAA;AASH;AANE;EACC,iBAAA;AAQH;AAUE;EACC,SAAA;EAEA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;AATH;AAYE;EACC,wBAAA;EACA,qCAAA;EACA,2BAAA;AAVH;AAYG;EACC,cAAA;AAVJ;AAcE;EACC,YAAA;EACA,WAAA;EACA,qBAAA;EACA,SAAA;AAZH;AAeE;EACC,WAAA;AAbH;;AAiBA;EACC,iBAAA;EACA,mBAAA;EACA,oBAAA;AAdD;AC/RE;ED0SF;IAKE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,gCAAA;EAZA;AACF;;AAkBA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EAEA,UAAA;EACA,qBAAA;EACA,kBAAA;AAhBD;;AAkBA;EACC,UAAA;EACA,aAAA;EACA,qBAAA;AAfD;;AAkBA;EACC,YAAA;EACA,gBAAA;AAfD;;AAkBA;EACC,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAfD;AAgBC;EACC,sBAAA;AAdF;;AAkBA;EACC,YAAA;EACA,gBAAA;EACA,2DACC;AAhBF;ACrUE;EDiVF;IAOE,YAAA;EAfA;AACF;AAiBC;EACC,SAAA;EACA,6CAAA;AAfF;;AAmBA;EACC,YAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mBAAA;AAjBD;AAmBC;EACC,UAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAjBF;AAoBC;EACC,WAAA;EACA,SAAA;EACA,kBAAA;EAEA,+BAAA;EACA,0BAAA;EACA,8BAAA;EAEA,sBAAA;EACA,kBAAA;AApBF;AAuBC;EACC,wBAAA;EACA,eAAA;EACA,+BAAA;AArBF;;AAyBA;EACC,eAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,uCAAA;EAEA,WAAA;AAvBD;ACvXE;EDsYF;IAUE,aAAA;EArBA;AACF;AAsBC;EACC,SAAA;AApBF;;AAwBA;EACC,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EAEA,aAAA;EACA,sBAAA;EAEA,kCAAA;AAvBD;AC5YE;EDuZF;IAcE,aAAA;EArBA;AACF;AAsBC;EACC,SAAA;AApBF;;AAwBA;EACC,cAAA;EACA,YAAA;EACA,mBAAA;AArBD;;AAwBA;EACC,eAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EAEA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,iCAAA;EACA,0BAAA;EAEA,aAAA;EACA,UAAA;EACA,qBAAA;AAxBD;ACjbE;EDwbF;IAmBE,WAAA;EAtBA;AACF;AAwBC;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,4CAAA;EACA,0BAAA;AAtBF;AAyBC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AAvBF;AAwBE;EACC,4BAAA;EACA,WAAA;AAtBH;;AA2BA;EACC,aAAA;AAxBD;;AA2BA;EACC,UAAA;AAxBD","sourcesContent":["@use '../../../theme/mixins' as *;\np,\nh1 {\n\tmargin: unset;\n}\n\nion-header {\n\tbox-shadow: none;\n}\n\n.toolbar {\n\tbackground: var(--background-default);\n\tflex-wrap: nowrap !important;\n\tdisplay: flex;\n\tp {\n\t\tcolor: white;\n\t\tfont-size: 10px;\n\t}\n}\n\n.category-block {\n\tbackground: #fff;\n}\nion-content {\n\tbackground: transparent !important;\n\t--background: transparent !important;\n}\nion-icon.brand-logo {\n\twidth: 140px;\n\theight: 18px;\n}\n\n.main {\n\toverflow: auto;\n}\n\n.item-responsive {\n\twidth: 100%;\n\t@include desktop {\n\t\twidth: calc(33.333% - 10px);\n\t\tmargin: 0 5px 10px;\n\t}\n}\n\n.articles-wrapper {\n\tpadding: 0 16px;\n\t@include desktop {\n\t\tmargin: 0 -16px;\n\t}\n}\n\nion-searchbar {\n\tpadding-inline-end: 12px;\n\tpadding-inline-start: 25px;\n\t--placeholder-color: #41413f;\n\t--placeholder-opacity: 1;\n\t--color: #41413f;\n\t--icon-color: #41413f;\n\t--border-radius: 10px;\n\t--border: none;\n\t--background: rgba(255, 255, 255, 0.15);\n\t@include desktop {\n\t\twidth: auto;\n\t}\n}\n.menu-heading {\n\tpadding-top: 10px;\n\tbackground: #e7f0f1;\n\tpadding-bottom: 10px;\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-bottom: 1px solid #e7f0f1;\n\t}\n}\n\n.list-title {\n\tmargin-bottom: 15px;\n}\n\n.orders {\n\toverflow: auto;\n\tflex: 1;\n\tpadding-bottom: 10px;\n}\n\n.items-wrap {\n\th3 {\n\t\tmargin-top: 0;\n\t\tmargin-bottom: 12px;\n\t\tfont-weight: bolder;\n\t}\n\n\t&:last-of-type {\n\t\t// min-height: 100%;\n\t}\n}\n\n.main-row {\n\theight: 100%;\n\toverflow: hidden;\n}\n\napp-order-content {\n\tdisplay: block;\n\theight: 100%;\n}\n\n.order-col {\n\tmin-width: 380px;\n}\n.category-header {\n\theight: 80px;\n\twidth: 100%;\n\tposition: relative;\n\t.category-headr-img {\n\t\theight: 80px;\n\t\twidth: 100%;\n\t\tobject-fit: cover;\n\t\topacity: 0.7;\n\t\tz-index: 0.6;\n\t}\n\th3 {\n\t\tposition: absolute;\n\t\tz-index: 10;\n\t\ttop: 50%;\n\t\tcolor: var(--ion-color-primary);\n\t\tleft: 25px;\n\t\ttransform: translateY(-50%);\n\t}\n\t@include desktop {\n\t\tmargin-top: 20px;\n\t}\n}\n\n.category-wrap {\n\tmargin-bottom: 22px;\n\t.category-info {\n\t\tpadding-left: 16px;\n\t\tbackground: white;\n\t\theight: 70px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: flex-start;\n\t\tposition: relative;\n\t\tbackground: linear-gradient(89.92deg, rgba(255, 255, 255, 0.98) 55%, rgba(0, 0, 0, 0) 100%);\n\t\tborder-width: 1px 0px 2px 0px;\n\t\tborder-style: solid;\n\t\tborder-color: #000000;\n\n\t\t.category-name {\n\t\t\twidth: 100%;\n\n\t\t\tword-break: break-word;\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 1;\n\t\t\t-webkit-box-orient: vertical;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\tmargin: 0px;\n\t\t\tz-index: 9999;\n\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 100%;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: capitalize;\n\n\t\t\tletter-spacing: 0.02em;\n\n\t\t\tcolor: #212326;\n\t\t}\n\n\t\t.category-description {\n\t\t\tz-index: 1;\n\t\t\tfont-family: AppFontAlt;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0;\n\t\t\tvertical-align: middle;\n\t\t\tcolor: #212326;\n\n\t\t\tmargin-top: 7px;\n\t\t}\n\n\t\tion-img {\n\t\t\tobject-fit: cover;\n\t\t\tright: 0px;\n\t\t\ttop: 0px;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tposition: absolute;\n\t\t\tz-index: -1;\n\t\t}\n\t}\n}\n\n// .first {\n// \tmargin-top: 10px;\n// }\n\n.header-wrap {\n\tpadding-left: 11px;\n}\n.padding-end {\n\tpadding-right: 11px;\n}\nion-footer {\n\tpadding: 20px;\n\tposition: fixed;\n\tbottom: 0;\n\tbackdrop-filter: blur(4px);\n\tbackground: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%);\n}\n.footer-btn {\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n.category-list {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n\n\ttransition: 1s linear;\n\topacity: 1;\n\tdisplay: flex;\n\toverflow: auto;\n\tscroll-behavior: smooth;\n\t-ms-overflow-style: none;\n\tscrollbar-width: none; /* Firefox */\n\n\tbackground-color: #fff;\n\theight: 64px;\n\tpadding-inline: 20px;\n\tmargin-bottom: 6px;\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t.chip {\n\t\t&:first-child {\n\t\t\tmargin-left: 0px;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-right: 0px;\n\t\t}\n\n\t\tflex: 0 0 auto;\n\t\t--icon-color: var(--ion-color-primary);\n\t\theight: 39px;\n\n\t\tbackground: transparent;\n\t\tborder: 1px solid #41413f;\n\t\ttransition: 200ms linear;\n\t\tmin-width: 41px;\n\t\tflex-direction: column;\n\t\tpadding: 0 15px !important;\n\t\tmargin: 0;\n\t\tborder-radius: 3px;\n\n\t\tjustify-content: center;\n\n\t\tion-label {\n\t\t\tmargin: 0;\n\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 14px;\n\t\t\tletter-spacing: 0;\n\t\t\tvertical-align: bottom;\n\t\t\ttext-transform: capitalize;\n\t\t\tcolor: #41413f;\n\t\t}\n\n\t\t&.selected {\n\t\t\ttransition: 200ms linear;\n\t\t\tbackground: var(--ion-color-tertiary);\n\t\t\tbox-shadow: 1px 1px 0px 1px;\n\n\t\t\tion-label {\n\t\t\t\tcolor: #050b05;\n\t\t\t}\n\t\t}\n\n\t\t.icon {\n\t\t\theight: 17px;\n\t\t\twidth: 17px;\n\t\t\t--icon-color: #41413f;\n\t\t\tmargin: 0;\n\t\t}\n\n\t\t&.chip-icon {\n\t\t\twidth: 39px;\n\t\t}\n\t}\n}\n.menu-heading {\n\tpadding-top: 10px;\n\tbackground: #6b5f4c;\n\tpadding-bottom: 10px;\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-bottom: 1px solid #e7f0f1;\n\t}\n}\n// .first {\n// \tmargin-top: 10px;\n// }\n\n.search-block {\n\theight: 64px;\n\tdisplay: flex;\n\talign-items: center;\n\n\topacity: 1;\n\ttransition: 1s linear;\n\tmargin-bottom: 6px;\n}\n.hidden {\n\topacity: 0;\n\tdisplay: none;\n\ttransition: 1s linear;\n}\n\n.main-row {\n\theight: 100%;\n\toverflow: hidden;\n}\n\n.service-not-available-container {\n\t--padding-start: 20px !important;\n\t--padding-end: 10px;\n\t--padding-top: 10px;\n\t--padding-bottom: 10px;\n\tion-icon {\n\t\tcolor: #fff !important;\n\t}\n}\n\n.banner-row {\n\theight: 48px;\n\toverflow: hidden;\n\ttransition:\n\t\ttransform 1s ease-in-out,\n\t\theight 1s ease-in-out;\n\t@include mobile {\n\t\theight: 60px;\n\t}\n\n\t&.hide {\n\t\theight: 0;\n\t\ttransform: rotateX(45deg) translate(0, -150%);\n\t}\n}\n\n.allergen-banner {\n\theight: 100%;\n\tbackground: #666666;\n\t// height: 39px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding-left: 16px !important;\n\tpadding-right: 16px;\n\n\tion-icon {\n\t\tfill: #fff;\n\t\tmargin-right: 15px;\n\t\theight: 27px;\n\t\twidth: 32px;\n\t}\n\n\t.info {\n\t\twidth: 100%;\n\t\tmargin: 0;\n\t\tpadding-block: 5px;\n\n\t\tfont-family: AppFont !important;\n\t\tfont-size: 10px !important;\n\t\tline-height: 13.2px !important;\n\n\t\tcolor: #fff !important;\n\t\ttext-wrap: balance;\n\t}\n\n\ta {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 10px;\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n\n.expand-block {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100vw;\n\tright: -100%;\n\ttop: 0;\n\tbackground: #0000001a;\n\n\tz-index: 10;\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t&.show {\n\t\tright: 0%;\n\t}\n}\n\n.sidebar {\n\tposition: absolute;\n\tright: -100%;\n\ttop: 0;\n\twidth: 35vw;\n\theight: 100vh;\n\tbackground: #fff;\n\tz-index: 11;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\ttransition: right 0.3s ease-in-out;\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t&.show {\n\t\tright: 0%;\n\t}\n}\n\napp-order-content {\n\tdisplay: block;\n\theight: 100%;\n\tbackground: #f2f2f2;\n}\n\n.fixed-notification {\n\tposition: fixed;\n\tbottom: 109px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\n\theight: 60px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tbackground: #1e1e1ccc;\n\tbackdrop-filter: blur(4px);\n\n\tz-index: 9999;\n\topacity: 0;\n\ttransition: 0.3s ease;\n\t@include desktop {\n\t\tbottom: 0px;\n\t}\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 50%;\n\t\ttransform: translateX(-50%);\n\t\tbottom: -12px;\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-left: 14px solid transparent;\n\t\tborder-right: 14px solid transparent;\n\t\tborder-top: 12px solid #1e1e1ccc;\n\t\tbackdrop-filter: blur(4px);\n\t}\n\n\t::ng-deep.inner-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0%;\n\t\tvertical-align: middle;\n\t\tcolor: #fff;\n\t\tpadding: 0 10px;\n\t\tspan {\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n}\n\n.placeholder-block {\n\theight: 200px;\n}\n\n.fixed-notification.show-item {\n\topacity: 1;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
